//import onClickOutside from "react-onclickoutside"
import UserAvatar from "@material-ui/core/Avatar"
import Box from "@material-ui/core/Box"
import { Link } from "gatsby"
import React, { Fragment } from "react"
import { FiChevronDown } from "react-icons/fi"
import { getAvator, getUser } from "../../utils"
import OutsideClick from "../OutsideClick/OutsideClick"
import { useDispatch, useSelector } from "react-redux"
import * as actionCommon from "../../store/actions/commonActions"
import AccountMenu from "../MainMenu/AccountMenu"

const Avator = props => {
  const { userSetting } = useSelector(state => ({
    userSetting: state.common.userSetting,
  }))
  const dispatch = useDispatch()
  const AvatorUrl = getAvator()
  const { firstName, lastName } = getUser()
  const handleClickOutside = () => {
    userSetting ? dispatch(actionCommon.userSettingPop(false)) : false
  }
  return (
    <OutsideClick outsideAction={handleClickOutside}>
      <Fragment>
        <Link
          className="nav-link dropdown-toggle no-caret"
          to="/"
          role="button"
          onClick={props.ProfileMediaClickFun}
        >
          <Box component="div" className="media">
            <Box component="div" className="media-img-wrap">
              <Box component="div" className="avatar">
                <UserAvatar
                  alt="User"
                  src={AvatorUrl}
                  className="avatar-img rounded-circle"
                />
              </Box>
              <Box
                component="span"
                className="badge badge-success badge-indicator"
              ></Box>
            </Box>
            <Box component="div" className="media-body">
              <Box component="span">
                {firstName} {" " + lastName}
                <i className="">
                  <FiChevronDown />
                </i>
              </Box>
            </Box>
          </Box>
        </Link>
      </Fragment>
      {/* {userSetting ? <AccountMenu /> : null} */}
    </OutsideClick>
  )
}
export default Avator
